var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "majesticons:open-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.16602 3.6665H5.49935C5.01312 3.6665 4.5468 3.85966 4.20299 4.20347C3.85917 4.54729 3.66602 5.01361 3.66602 5.49984V16.4998C3.66602 16.9861 3.85917 17.4524 4.20299 17.7962C4.5468 18.14 5.01312 18.3332 5.49935 18.3332H16.4993C16.9856 18.3332 17.4519 18.14 17.7957 17.7962C18.1395 17.4524 18.3327 16.9861 18.3327 16.4998V12.8332M10.9993 10.9998L18.3327 3.6665M18.3327 3.6665V8.24984M18.3327 3.6665H13.7493",
    stroke: "#4F4F4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/Redirect_icon.142063a813eb6db5dfe552c5fb0fc79a.svg";
export { ForwardRef as ReactComponent };